var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',_vm._b({class:{
  'text-none': true,
  'background darken-1': _vm.loading
},attrs:{"depressed":"","disabled":_vm.loading},on:{"click":function($event){return _vm.$emit('click')}}},'v-btn',_vm.$attrs,false),[(!_vm.loading)?_c('div',{class:{ 'text-caption': _vm.$mobileBreakpoint }},[_vm._t("default")],2):_c('div',{staticClass:"d-flex align-center"},[_c('span',{class:{ 'text-caption': _vm.$mobileBreakpoint },style:({
      color: 'rgba(0,0,0,0.5)',
    })},[_vm._t("loadingText")],2),_c('v-progress-circular',{staticClass:"ml-2 ml-md-4",attrs:{"size":_vm.$mobileBreakpoint ? 16 : 24,"width":"2","color":"primary","indeterminate":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }